export default __webpack_public_path__ + "static/media/2021-campostelo.0176e9c3.png";